export const service = {
  appDomain: process.env.NEXT_PUBLIC_APP_DOMAIN as string,
  baseUrl: process.env.NEXT_PUBLIC_BASE_URL as string,
  agentUrl: process.env.NEXT_PUBLIC_AGENT_URL as string,
  version: process.env.NEXT_PUBLIC_API_VERSION as string,
  siteKey: process.env.NEXT_PUBLIC_SITE_KEY as string,
  userService: process.env.NEXT_PUBLIC_USER_SERVICE as string,
  authService: process.env.NEXT_PUBLIC_AUTH_SERVICE as string,
}
